import Wizard from '@/components/wizard/Wizard.vue';
import WizardSection from '@/components/wizard/Section.vue';

/**
 * Mixin kreatora
 */
export const wizardMixin = {
  data: () => ({
    activeTab: 0
  }),
  components: {
    Wizard,
    WizardSection
  },
  methods: {
    // @vuese
    // Ustawia następną zakładkę
    nextTab() {
      this.setActiveTab(this.activeTab + 1);
    },

    // @vuese
    // Ustawia poprzednią zakładkę
    previousTab() {
      this.setActiveTab(this.activeTab - 1);
    },

    // @vuese
    // Ustawia ntą zakładkę
    setActiveTab(val) {
      this.$set(this, 'activeTab', val);
    },

    // @vuese
    // Przeładowuje routing na odpowiednią zakładkę
    changeTab() {
      if (this.tabs.length && this.tabs[this.activeTab].name) {
        this.$router.push({
          name: this.tabs[this.activeTab].name,
          params: this.$route.params
        });
      }
    }
  },
  watch: {
    activeTab() {
      this.changeTab();
    }
  }
};
